/**
 * Home component
 */
import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { selectSitesAndSelectedSites } from '@rpt-ngrx/selectors/sites.selector';

@Component({
    selector: 'dm-home',
    styleUrls: ['./home.component.scss'],
    templateUrl: './home.component.html',
})
export class HomeComponent implements OnDestroy {
    private unsubscribe$: Subject<void> = new Subject();

    constructor(
        private store: Store,
        private router: Router,
    ) {
        this.store
            .select(selectSitesAndSelectedSites)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(({ sites }) => {
                if (sites.length > 0) {
                    this.router.navigate(['/custom-reports']);
                }
            });
    }

    public ngOnDestroy() {
        this.unsubscribe$.next();
    }
}
